import config from "../app-config";
import serverFetch from "../utils/serverFetch";

export const fetch_all_claims = async () => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/claims/`,
        method: "GET"
    }))
}

export const create_new_claim = async (formData) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/claims/`,
        method: "POST",
        body: formData,
        type: "formData"
    }))
}

export const update_claim = async (claim_id, formData) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/claims/id/${claim_id}`,
        method: "PUT",
        body: formData,
        type: "formData"
    }))
}

export const delete_claim = async (claim_id) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/claims/id/${claim_id}`,
        method: "DELETE"
    }))
}

export const fetch_claim_by_id = async (claim_id) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/claims/id/${claim_id}`,
        method: "GET"
    }))
}

export const fetch_claims_by_account_id = async (account_id) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/claims/account/id/${account_id}`,
        method: "GET"
    }))
}

export const approve_claim = async (claim_id) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/claims/id/${claim_id}/approve`,
        method: "POST",
    }))
}

export const reject_claim = async (claim_id) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/claims/id/${claim_id}/reject`,
        method: "POST",
    }))
}

export const process_payment = async (claim_id) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/claims/id/${claim_id}/payment`,
        method: "POST",
    }))
}

export const mark_claim_as_reimbursed = async (claim_id) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/claims/id/${claim_id}/paid`,
        method: "POST",
    }))
}

export const fetch_user_claims = async () => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/claims/user/claims`,
        method: "GET"
    }))
}

export const fetch_user_claims_by_claims_id = async (claim_id) => {
    return (await serverFetch({
        endpoint: `${config.endpoint}/claims/user/claims/id/${claim_id}`,
        method: "GET"
    }))
}